import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import { Density } from "../baseQuantities/density";
import { Length } from "../baseQuantities/length";
import { Pressure } from "../baseQuantities/pressure";
import { UnitLess } from "../baseQuantities/unitLess";
import { SurfaceFinish } from "../baseQuantities/surfaceFinish";
import { Velocity } from "../baseQuantities/velocity";
import turbulentFlowImg from "../../img/calc-figure-pipePressureDrop-turbulent.png";
import laminarFlowImg from "../../img/calc-figure-pipePressureDrop-laminar.png";

const turbulentMode: CalcMode = {
  id: "001turbulentflowpressuredrop",
  name: "turbulent_flow",
  baseQuantities: [
    { ...Density },
    { ...UnitLess, name: "reynolds", symbol: "Re" },
    { ...SurfaceFinish },
    { ...Length, name: "inner_diameter", selectedUnit: "mm", symbol: "Di" },
    { ...Length, name: "pipe_length", selectedUnit: "m", symbol: "L" },
    { ...Velocity, symbol: "u" },
    { ...Pressure, name: "pressure_drop", symbol: "\u0394p" },
  ],
  figure: turbulentFlowImg,
  equation:
    "v\u00B2\u03C1L/D\u1D62/2*(-1/(1.8log(6.9/Re+(\u03B5/D\u1D62/3.7)\u00B9\u22C5\u00B9)))\u00B2",
};

const laminarMode: CalcMode = {
  id: "001laminarflowpressuredrop",
  name: "laminar_flow",
  baseQuantities: [
    { ...Density },
    { ...UnitLess, name: "reynolds", symbol: "Re" },
    { ...Length, name: "inner_diameter", selectedUnit: "mm", symbol: "Di" },
    { ...Length, name: "pipe_length", selectedUnit: "m", symbol: "L" },
    { ...Velocity, symbol: "u" },
    { ...Pressure, name: "pressure_drop", symbol: "\u0394p" },
  ],
  figure: laminarFlowImg,
};

// const airMode: CalcMode = {
//   id: "001instrumentairpressuredrop",
//   name: "instrument_air",
//   baseQuantities: [
//     { ...Density },
//     { ...Length, name: "pipe_length", selectedUnit: "m", symbol: "L" },
//     { ...Length, name: "inner_diameter", selectedUnit: "mm", symbol: "Di" },
//     { ...Velocity, symbol: "u" },
//   ],
// };

export const pipePressureDropCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "pipe pressure drop",
  branch: "Fluids",
  difficulty: "complex",
  inputs: [turbulentMode, laminarMode],
  calculate: [
    {
      name: "turbulent_flow",
      equations: [
        {
          target: "pressure_drop",
          expression:
            "(density) * (pipe_length) / (inner_diameter) * (velocity)^2 / 2 * (-1 / (1.8*log(6.9 / (reynolds) + ((surface_finish) / (inner_diameter) / 3.7)^1.1)))^2",
          // expression:
          //   "(-1 / (1.8*log(6.9 / (reynolds) + ((surface_finish) / (inner_diameter) / 3.7)^1.1)))^2",
        },
        {
          target: "pipe_length",
          expression:
            "(pressure_drop) * (inner_diameter) * 2 / (velocity)^2 / (density) / ((-1 / (1.8*log(6.9 / (reynolds) + ((surface_finish) / (inner_diameter) / 3.7)^1.1)))^2)",
        },
        {
          target: "velocity",
          expression:
            "root((pressure_drop) * (inner_diameter) * 2 / (density) / (pipe_length) / ((-1 / (1.8*log(6.9 / (reynolds) + ((surface_finish) / (inner_diameter) / 3.7)^1.1)))^2))",
        },
        {
          target: "density",
          expression:
            "(pressure_drop) * (inner_diameter) * 2 / (velocity)^2 / (pipe_length) / ((-1 / (1.8*log(6.9 / (reynolds) + ((surface_finish) / (inner_diameter) / 3.7)^1.1)))^2)",
        },
      ],
    },
    {
      name: "laminar_flow",
      equations: [
        {
          target: "pressure_drop",
          expression:
            "(density) * (pipe_length) / (inner_diameter) * (velocity)^2 / 2 * (64 / (reynolds))",
        },
        {
          target: "pipe_length",
          expression:
            "(pressure_drop) * (inner_diameter) * 2 / (velocity)^2 / (density) / (64 / (reynolds))",
        },
        {
          target: "velocity",
          expression:
            "root((pressure_drop) * (inner_diameter) * 2 / (density) / (pipe_length) / (64 / (reynolds)))",
        },
        {
          target: "density",
          expression:
            "(pressure_drop) * (inner_diameter) * 2 / (velocity)^2 / (pipe_length) / (64 / (reynolds))",
        },
        {
          target: "inner_diameter",
          expression:
            "(density) * (pipe_length) / (pressure_drop) * (velocity)^2 / 2 * (64 / (reynolds))",
        },
        {
          target: "reynolds",
          expression:
            "(density) * (pipe_length) / (inner_diameter) * (velocity)^2 / 2 * (64 / (pressure_drop))",
        },
      ],
    },
  ],
};
